import React from 'react';
import PropTypes from 'prop-types';
import {
  IconButton, makeStyles, Tooltip,
} from '@material-ui/core';
import {
  Copy as CopyIcon,
} from 'react-feather';
import { DEFAULT_MUI_DATATABLE_BUTTON_SIZE } from 'constantes/constants';
import { withPermissionsChecker } from 'wrappers';

const useStyles = makeStyles(theme => ({
  icon: {
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}));

/**
 * This component allows to render a button specific to update
 * @param {*} param0
 */
const DuplicateButton = ({
  onClick, requiredPermissions = [], checkAccess, disabled,
}) => {
  const classes = useStyles();
  return (
    <Tooltip title="Duplicar">
      <IconButton
        size={DEFAULT_MUI_DATATABLE_BUTTON_SIZE}
        className={classes.icon}
        onClick={onClick}
        disabled={!checkAccess(requiredPermissions) || disabled}
      >
        <CopyIcon />
      </IconButton>
    </Tooltip>
  );
};

DuplicateButton.defaultProps = {
  requiredPermissions: [],
};

DuplicateButton.propTypes = {
  onClick: PropTypes.func,
  checkAccess: PropTypes.func,
  requiredPermissions: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
};

export default withPermissionsChecker(DuplicateButton);
